<div
  data-at-panel
  *ngIf="active"
  class="panel {{ program }} {{ size }} flex flex-col flex-auto"
  [@toggle]
>
  <div data-at-panel-body class="flex flex-row lt-sm:flex-wrap justify-between items-center">
    <div
      class="flex flex-row lt-sm:flex-col gap-[10px] justify-start items-center lt-sm:items-start flex-1"
    >
      <div
        data-at-message
        class="message flex flex-row gap-[19px] lt-lg:gap-[15px] justify-start items-center"
      >
        <ng-content select="[icon]"></ng-content>
        <span>
          <ng-content select="[message]"></ng-content>
        </span>
      </div>
      <span data-at-description class="description">
        <ng-content select="[description]"></ng-content>
      </span>
    </div>
    <ng-content select="[button]"></ng-content>
  </div>
</div>
